import React from "react";


class Landing extends React.Component {

    render() {
        return <div className="full_center_container" style={{height: '80vh'}}>
            <div>
                <div className="flex_center" style={{padding: '64px'}}>
                    <img src={"logo.png"} width='24%' alt='yomi logo'/>
                </div>
                <div className="flex_row flex_center">
                    <a href="https://apps.apple.com/dk/app/yomi/id1482611785" target="_blank"
                       rel="noopener noreferrer" className="hero-button hero-button-row">
                        <span>DOWNLOAD FOR</span><i className="fa fa-apple"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.oleeapp.yomi"
                       rel="noopener noreferrer" className="hero-button hero-button-row">
                        <span>DOWNLOAD FOR</span><i className="fa fa-android"/>
                    </a>
                </div>
            </div>
        </div>
    }
}

export default Landing
